const Rellax = require('rellax');

const rellaxInstances = {
    init() {
        /**
         * Parallax-Scrolling initialisieren
         */
        // Vintage/Neu-Box auf der Startseite
        if (document.querySelector('.rellax')) {
            // eslint-disable-next-line no-new
            new Rellax('.rellax', {
                center: true,
            });
        }

        // "Über Uns"
        if (document.querySelector('.js-parallax-image')) {
            // eslint-disable-next-line no-new
            new Rellax('.js-parallax-image');
        }
    },
};

export default rellaxInstances;
